import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseAuthTerms.module.scss'

import MyhouseRegisterHeader from '@Components/atoms/MyhouseRegisterHeader'
import BlindContent from '@Components/atoms/BlindContent'
import { MYHOUSE_REGISTER_TERMS } from '@Root/contants/myhouseRegister'
import MyhouseAuthTermsCollect from '@Components/atoms/MyhouseAuthTermsCollect'

const cx = className.bind(style)

type Props = {
  termsType: MYHOUSE_REGISTER_TERMS
  onCloseClick: (event: React.SyntheticEvent) => void
}

const MyhouseAuthTerms: React.FC<Props> = ({ termsType, onCloseClick }: Props) => {
  return (
    <>
      <MyhouseRegisterHeader onPrevClick={onCloseClick} />
      <section id="content" className={cx('article')} role="main">
        <BlindContent />
        <div className={cx('inner')}>
          <MyhouseAuthTermsCollect />
        </div>
        <button type="button" className={cx('button_confirm')} onClick={onCloseClick}>
          확인
        </button>
      </section>
    </>
  )
}

export default MyhouseAuthTerms
